import { InjectionToken } from '@angular/core';

export const IS_SMARTEDIT = new InjectionToken<any>('IsSmartedit');
